import { faStar } from '@fortawesome/free-regular-svg-icons'
import PageHeader from '../../../components/PageHeader'
import { Box, FormControl, MenuItem, Select, useTheme } from '@mui/material'
import HFCard from '../../../components/HFCard'
import { useEffect, useState } from 'react'
import * as service from './services'
import SinglePractice from './demos/SinglePractice'
import { useAppDispatch, useAppSelector } from '../../../redux/store'
import { selectCurrentCustomerNumber } from '../../../redux/customer'
import Corporate from './demos/Corporate'
import Groups from './demos/Groups'
import Medications from './demos/Medications'
import Devices from './demos/Devices'
import BiologicalMonitoring from './demos/BiologicalMonitoring'
import UnusedMedications from './demos/UnusedMedications'
import Amalgam from './demos/Amalgam'
import MedicalWaste from './demos/MedicalWaste'
import TimeBasedRefill from './demos/TimeBasedRefill'
import WaterlineManagement from './demos/WaterlineManagement'
import constants from '../../../constants'
import './Demo.css'
import { addError, addSuccess } from '../../../redux/alerts'

const demoModes = {
  dental: 'Dental',
  medical: 'Medical'
}

const Demo = () => {
  const isDemoEnvironment = constants.ENV.toLowerCase() === 'demo';

  useEffect(() => {
    if (!isDemoEnvironment) {
      window.location.href = `/`
    }
  }, [isDemoEnvironment])

  const theme = useTheme()
  const customerNumber = useAppSelector(selectCurrentCustomerNumber)
  const dispatch = useAppDispatch();
  const [demoMode, setDemoMode] = useState(demoModes.dental)

  const handleChangeDemoMode = (mode: string) => setDemoMode(mode)

  const triggerDemo = async (demo: string) => {
    try {
      await service.triggerDemo(demo, customerNumber)
      dispatch(addSuccess('An email will be sent once the demo has completed.'))
    } catch (err) {
      console.error(err)
      dispatch(addError(err instanceof Error ? err.message : 'There was an issue processing this demo'))
    }
  }

  const sendTbrItems = async () => {
    try {
      await service.sendTbrItems(customerNumber)
      dispatch(addSuccess('An email will be sent once the demo has completed.'))
    } catch (err) {
      console.error(err)
      dispatch(addError(err instanceof Error ? err.message : 'There was an issue processing this demo'))
    }
  }

  return (
    <>
      <PageHeader iconName={faStar} headerName={'Demo'} size={'26px'} />
      <Box sx={{ color: theme.palette.color50555b.main, padding: '16px' }} className="demo-container">
        <Box>
          <HFCard headerText={`Demo ${demoMode} Mode`}>
            <div className='card-body'>
              <FormControl fullWidth>
                <Select
                  name="demo-mode"
                  value={demoMode}
                  onChange={(e) => handleChangeDemoMode(e.target.value)}
                  sx={{ height: '32px' }}
                >
                  {Object.values(demoModes).map((mode) => (
                    <MenuItem key={mode} value={mode}>
                      {mode}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </HFCard>

          <SinglePractice demoMode={demoMode} triggerDemo={triggerDemo} />
          <Corporate demoMode={demoMode} triggerDemo={triggerDemo} />
          <Groups demoMode={demoMode} triggerDemo={triggerDemo} />
          <Medications demoMode={demoMode} triggerDemo={triggerDemo} />
          <Devices demoMode={demoMode} triggerDemo={triggerDemo} />
          <BiologicalMonitoring demoMode={demoMode} triggerDemo={triggerDemo} />
          <UnusedMedications demoMode={demoMode} triggerDemo={triggerDemo} />
          <Amalgam demoMode={demoMode} triggerDemo={triggerDemo} />
          <MedicalWaste demoMode={demoMode} triggerDemo={triggerDemo} />
          <TimeBasedRefill demoMode={demoMode} triggerDemo={triggerDemo} sendTbrItems={sendTbrItems} />
          <WaterlineManagement demoMode={demoMode} triggerDemo={triggerDemo} />
        </Box>
      </Box>
    </>
  )
}

export default Demo